const getChannelTransFuncParam = (channelTrans) => {
  if (channelTrans && channelTrans.includes('get_channel_trans')) {
    const matches = channelTrans.match(/get_channel_trans\(([^)]+)\)/)
    return matches !== null ? matches[1] : channelTrans
  }
  return undefined
}

export default getChannelTransFuncParam
